import React from 'react';
import { Glyphicon, Button, Popover } from 'react-bootstrap';
import { DragSource, DropTarget } from 'react-dnd';
import { Components, UnknownComponent } from '../../config/components';
import PageActions from '../../actions/page';
import PlaceholderComponent from '../../components/page/placeholder-component';
import '../../../css/page/component-wrapper.less';

const componentSource = {
    beginDrag (props, monitor, component) {
        return {
            componentType: props.component.componentType,
            developerName: props.component.developerName,
            id: props.component.id,
            order: props.component.order,
            pageContainerId: props.component.pageContainerId
        };
    },
    endDrag (props, monitor, component) {
        if (monitor.didDrop())
            props.onEndDrag();
    },
    canDrag (props, monitor) {
        return !props.droppedOn && !props.editing.id && props.highlight === props.component.id;
    },
    isDragging (props, monitor) {
        return props.component && (props.component.id == monitor.getItem().id);
    }
};
@DragSource('component', componentSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
}))
class ComponentWrapper extends React.Component {

    constructor(props) {
        super(props);
        this.state = { isPopoverVisible: false };
        this.onClick = this.onClick.bind(this);
        this.onMoveUp = this.onMoveUp.bind(this);
        this.onMoveDown = this.onMoveDown.bind(this);
    }

    onClick(e) {
        e.stopPropagation();

        if (!this.props.editing.id && this.props.highlight !== this.props.component.id)
            PageActions.setHighlightedElement(this.props.component.id, this.props.pageId)
    }

    onMoveUp(e) {
        let order = parseInt(this.props.component.order);
        PageActions.moveItemUp(this.props.pageId, this.props.component, this.props.component.pageContainerId, order);
    }

    onMoveDown(e) {
        let order = parseInt(this.props.component.order);
        PageActions.moveItemDown(this.props.pageId, this.props.component, this.props.component.pageContainerId, order);
    }

    render() {
        const { connectDragSource, connectDragPreview, isDragging } = this.props;

        const classes = ['component-wrapper'];

        if (manywho.utils.isEqual(this.props.componentType, 'mw-placeholder', true)) {
            return (<PlaceholderComponent flowKey={this.props.flowKey}></PlaceholderComponent>);
        }

        let component = Components.filter((item) => {
            for (const alias of item.alias)
                if (manywho.utils.isEqual(alias, this.props.component.componentType, true))
                    return true;
            return manywho.utils.isEqual(item.id, this.props.component.componentType, true);
        })[0];

        let element = null;

        if (component)
            element = React.createElement(manywho.component.getByName(this.props.component.componentType), {
                flowKey: this.props.flowKey,
                id: this.props.component.id,
                isDesignTime: true
            });
        else
            component = UnknownComponent;

        const mainClasses = ['component-wrapper-main'].concat(manywho.styling.getClasses(this.props.component.pageContainerId, this.props.component.id, this.props.component.componentType, this.props.flowKey));
        const dragClasses = ['component-handle', 'bg-primary', 'element-actions'];

        if (this.props.disabled)
            dragClasses.push('disabled');

        if (this.props.highlight === this.props.component.id)
            classes.push('highlight');

        if (this.props.editing.id == this.props.component.id)
            classes.push('editing');

        if (isDragging)
            mainClasses.push('semi-transparent');

        if (this.props.side) {
            classes.push(`drop-${this.props.side}`);
            classes.push('drop-target');
        }

        const componentButtons = [];

        if (!this.props.disabled && !this.props.editing.id) {
            if (this.props.siblingNumber > 1 && parseInt(this.props.component.order) > 0)
                componentButtons.push(<Button key="component-move-up" disabled={this.props.highlight !== this.props.component.id} className="component-move element-actions btn-nobackground" onClick={this.onMoveUp}><Glyphicon glyph="arrow-up"></Glyphicon></Button>);

            if (this.props.siblingNumber > 1 && parseInt(this.props.component.order) < this.props.siblingNumber - 1)
                componentButtons.push(<Button key="component-move-down" disabled={this.props.highlight !== this.props.component.id} className="component-move element-actions btn-nobackground" onClick={this.onMoveDown}><Glyphicon glyph="arrow-down"></Glyphicon></Button>);

            componentButtons.push(<Button key="component-edit" disabled={this.props.highlight !== this.props.component.id} className="component-edit element-actions btn-nobackground" onClick={PageActions.editComponent.bind(null, 'edit', this.props.component, this.props.component.order, this.props.pageId)}><Glyphicon glyph="cog"></Glyphicon></Button>);
            componentButtons.push(<Button key="component-remove" disabled={this.props.highlight !== this.props.component.id} bsStyle="danger" className="component-remove btn-danger element-actions btn-nobackground" onClick={PageActions.removeComponent.bind(null, this.props.component.id, this.props.pageId)}><Glyphicon glyph="remove"></Glyphicon></Button>);
        }

        return connectDragPreview(
            <div id={'element-' + this.props.component.id} className={mainClasses.join(' ')}>
                <div ref={component.id} className={classes.join(' ')} onClick={this.onClick}>
                    <div className="component-editing clearfix">
                        { connectDragSource(<div className={dragClasses.join(' ')}><Glyphicon glyph="move"></Glyphicon></div>) }
                        <span className="component-name">{this.props.component.componentType + ': ' + this.props.component.developerName}</span>
                        <span className="component-wrapper-actions">
                            {componentButtons}
                        </span>
                    </div>
                    {element}
                </div>
            </div>
        );

    }

}

export default ComponentWrapper;
